import { createApp } from 'vue'
import App from './App.vue'
import {router} from "@/routes";

createApp(App,{
    ...document.getElementById("exc-catalog")?.dataset
}).use(router).mount('#exc-catalog')
